import React, {PureComponent} from "react";
import {setPropertyPx} from "./library";
import {
    createCardLocator,
    fitImageToFigure,
    selectImage
} from "./imageSizing";

//
// Originally I thought about having Apollo be separate from the PhotoShell but
// decided to make it a page inside the PhotoShell so we could take advantage of the
// features it provides
//

export default class Apollo extends PureComponent {
    constructor(props) {
        super(props);
        const {config} = props
        const backs = {}
        for(const i of config.backs) {
            backs[i["name"]] = i
        }

        this.state = {
            imageURL: false,
            backSideURL: null,
            fitX: null,
            fitY: null,
            backs,
            dimensions: {
                titleHeight: 85,
            }
        };
    }

    componentDidMount = async () => {
        this.props.registerAdapt(this.adaptToSize)
    }

    componentDidUpdate = async () => {
        const {adaptToSize} = this.props
        const {backSideURL, backSideLinks, backSideWidth, backSideHeight} = this.state;
        adaptToSize()
        if (backSideURL) {
            const canvas = document.getElementById('backOverlay');
            const ctx = canvas.getContext('2d')
            ctx.clearRect(0,0,backSideWidth,backSideHeight)
            ctx.strokeStyle="grey"
            ctx.rect(0,0,backSideWidth,backSideHeight)
            ctx.stroke()
            ctx.beginPath()
            ctx.strokeStyle="black"
            ctx.moveTo(backSideWidth-1,0)
            ctx.lineTo(backSideWidth-1, backSideHeight)
            ctx.moveTo(0,backSideHeight-1)
            ctx.lineTo(backSideWidth, backSideHeight-1)
            ctx.stroke()

            for(const link of backSideLinks) {
                ctx.strokeStyle="blue"
                ctx.fillStyle="rgba(0,0,255,0.3)"
                const { left, top, right, bottom} = link

                ctx.strokeRect(
                    left*backSideWidth,
                    top*backSideHeight,
                    (right-left) * backSideWidth,
                    (bottom-top) * backSideHeight)
                ctx.fillRect(
                    left*backSideWidth,
                    top*backSideHeight,
                    (right-left) * backSideWidth,
                    (bottom-top) * backSideHeight)
            }
        }
    }

    componentWillUnmount = () => {
        this.props.registerAdapt(undefined)
    }

    adaptToSize = ({navWidth, articleWidth}) => {
        const { config , pathname } = this.props
        const { cards, images } = config
        const { dimensions, backSideURL } = this.state
        const { titleHeight } = dimensions

        setPropertyPx('--titleHeight', titleHeight)
        setPropertyPx('--bottomHeight', 0)
        const figureHeight = window.innerHeight - titleHeight
        const imgSize = [images[0].width, images[0].height]
        const [fitX, fitY] = fitImageToFigure(imgSize, [articleWidth, figureHeight])
        setPropertyPx('--imgWidth', fitX)
        setPropertyPx('--imgHeight', fitY)
        const scaledX = fitX * window.devicePixelRatio
        const scaledY = fitY * window.devicePixelRatio
        const selectedImage = selectImage(images, scaledX, scaledY)

        if(backSideURL) {
            const theBack = document.getElementsByClassName("theBack")[0];
            setPropertyPx("--backTop", (window.innerHeight-theBack.clientHeight)/2)
            setPropertyPx("--backLeft", (window.innerWidth-theBack.clientWidth)/2)
        }
        const newState = {
            isReady: true,
            imageURL: pathname + selectedImage.name,
            fitX: fitX,
            fitY: fitY,
        };
        if (fitX!==this.state.fitX || fitY!==this.state.fitY) {
            newState.cardLocator = createCardLocator(cards, [fitX, fitY])
        }
        this.setState(newState)
    }

    onClick = (event) => {
        const {cardLocator, backs} = this.state
        const {left, top} = event.target.getBoundingClientRect()

        const xImg = event.clientX - left
        const yImg = event.clientY - top
        const thatCard = cardLocator([xImg, yImg])
        const name = `BACK800/${thatCard.card_id}.PNG`
        this.setState({
            backSideURL: name,
            backSideLinks: thatCard.back_links,
            backSideWidth: backs[name].width,
            backSideHeight: backs[name].height,
        })
    }

    backClick = (event) => {
        const {left, top} = event.target.getBoundingClientRect()
        const {backSideLinks, backSideWidth, backSideHeight} = this.state;

        const xImg = event.clientX - left
        const yImg = event.clientY - top

        //
        // these coordinates work like ordinary computer coordinates (y is 0 at top and works down)
        // but are scaled so that the bottom is 1.0 and right side is 1.0
        //

        const backX = xImg / backSideWidth
        const backY = yImg / backSideHeight

        const matchLink = () => {
            for(const link of backSideLinks) {
                const { left, top, right, bottom} = link
                if (backX>=left && backX<=right && backY>=top && backY<=bottom) {
                    return link
                }
            }
            return null;
        }

        const link = matchLink()
        if(link==null) {
            this.setState({
                "backSideURL": null
            })
        } else {
            window.open(link.url, link.url)
        }

    }

    render = () => {
        const {imageURL, backSideURL, backSideHeight, backSideWidth} = this.state
        const {config} = this.props
        const {onClick, backClick} = this
        const {title} = config

        return <article className={"Apollo"}>
            <div className={"heading"}><h1>{title}</h1></div>
            <div className={"figure"}>{imageURL ? <img src={imageURL} alt={title} onClick={onClick}/> : undefined}</div>
            {backSideURL && <><div className={"theBack"} >
                <img src={backSideURL} alt={"Rear Side of ..."} height={backSideHeight} width={backSideWidth}/>
            </div>
                <canvas id="backOverlay" height={backSideHeight} width={backSideWidth} onClick={backClick} />
            </>}
        </article>;
    }

    static page_title = "Constellation"
}
